import { Box, Breadcrumbs, Link, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import EventAttendeesChart from '../Chart/EventAttendeesChart'
import EventParticipantChart from '../Chart/EventParticipantChart'
import { backgroundColors } from '../../../Common/Color/Color'
import TeamMemberTable from './TeamMemberTable'
import { useAppDispatch } from '../../../../redux/store'
import { fetchInvitedTeamMembers } from '../../../../redux/reports/event/invitedTeamMemberPerEvent/action'
import { LinkProps, Link as RouterLink, useParams } from 'react-router-dom'
import { useAppSelector } from '../../../../redux/hooks'
import {
  selectInvitedTeamMemberReport,
  selectInvitedTeamMembersLoading,
} from '../../../../redux/reports/event/invitedTeamMemberPerEvent/selector'
import PageLoading from '../../../Common/Loading/PageLoading'

const ViewEvent: React.FC = () => {
  const dispatch = useAppDispatch()
  const eventDetails = useAppSelector(selectInvitedTeamMemberReport)
  const loading = useAppSelector(selectInvitedTeamMembersLoading)

  const { id: eventId } = useParams<{ id: string }>()

  useEffect(() => {
    // Fetch invited team members when the component mounts
    if (eventId) {
      dispatch(fetchInvitedTeamMembers({ eventId }))
    }
  }, [dispatch, eventId])

  interface LinkRouterProps extends LinkProps {
    to: string
    replace?: boolean
  }

  function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={RouterLink as any} underline='hover' color='inherit' />
  }

  if (loading) {
    return <PageLoading message='Loading' subMessage='Fetching team member' />
  }

  return (
    <React.Fragment>
      <Box
        component='div'
        sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
        borderRadius={2}
        boxShadow={1}
      >
        {!loading && !eventDetails && (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant='h6'>No event details found.</Typography>
          </Box>
        )}

        {!loading && eventDetails && (
          <>
            <Box sx={{ p: 2 }}>
              <Breadcrumbs aria-label='breadcrumb'>
                <LinkRouter to='/reports/event'>Events</LinkRouter>
                <Typography sx={{ color: 'text.primary' }}>{eventDetails?.eventTitle}</Typography>
              </Breadcrumbs>
            </Box>

            <Box sx={{ px: 2 }}>
              <EventAttendeesChart />
              <EventParticipantChart />
            </Box>
            <TeamMemberTable />
          </>
        )}
      </Box>
    </React.Fragment>
  )
}

export default ViewEvent
